import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {$accountFactory} from "../../$account.factory";
import {AccountDialogService} from "../../services/account-dialogs-service.service";
import {VehiclesAlerts} from "../../../vehicles/services/vehicles-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class AccountVehiclesCtrl implements IController {

  account: AccountModel;
  loading: any;
  selectedVehicle: any;

  private vehicleIndex: any;

  /* @ngInject */
  constructor(private vehiclesAlerts: VehiclesAlerts, private $account: $accountFactory, private accountDialogService: AccountDialogService,
              private confirmDialogService: ConfirmDialogService, private $log) {
  }

  $onInit() {
    this.vehicleIndex = 0;
  }

  addNewVehicle(event) {
    if (this.account) {
      this.accountDialogService.createNewVehicle(event, this.account).then(
        (updatedAccount) => {
          this.account = updatedAccount;
          this.selectedVehicle = updatedAccount.vehicles[updatedAccount.vehicles.length - 1];
          this.vehiclesAlerts.createSuccess();
        });
    }
  }

  // removeVehicle(event, index) {
  //   const text = 'Are you sure you want to delete vehicle?';
  //   this.confirmDialogService.confirm('Confirm Vehicle Delete', text, event).then(() => {
  //
  //     if (!_.isUndefined(index)) {
  //       this.account.vehicles.splice(index, 1);
  //       this.$account(this.account.id).$post(this.account).then(
  //         (updatedAccount) => {
  //           this.account = updatedAccount;
  //           this.vehiclesAlerts.deleteOneSuccess();
  //         });
  //     }
  //   });
  // }


  selectVehicle(selectedVehicle, index) {
    this.selectedVehicle = selectedVehicle;
    this.vehicleIndex = index;
  }

  updateAccount(updatedAccount) {
    this.account = updatedAccount;
    this.selectedVehicle = updatedAccount.vehicles[this.vehicleIndex];
  }


  updateActiveState() {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.$account(this.account.id).$post(this.account).then(
        (updatedAccount) => {
          this.account = updatedAccount;
          this.loading = false;
          resolve(updatedAccount);

        },
        (error) => {
          this.$log.error('Failed to update vehicle active state, ' +
            'accountVehiclesCtrl@changeActiveState \n' + error);
          this.loading = false;
          reject(error);
        }
      );
    });
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountVehicles', {
    bindings: {
      account: '<',
      loading: '<',
      selectedVehicle: '<'
    },
    template: require('./account-vehicles.html').default,
    controller: AccountVehiclesCtrl
  });
